<template>
  <div>
    <!--blog Section start-->
    <div class="page-margin">
      <!--breadcrumb start-->
      <div class="breadcrumb-bg">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-text-center d-align-center">
              <h2 class="title">
                blog<span> Details</span>
              </h2>
            </div>
            <div class="col-md-6 col-sm-6 col-text-center">
              <nav
                aria-label="breadcrumb"
                class="blog-bradcrumb "
              >
                <ol class="breadcrumb bg-transparent mb-0">
                  <li class="breadcrumb-item">
                    <a href="/">
  Home
</a>

                  </li>
                  <li class="breadcrumb-item active">
                    <a href="#">
  Blog Details
</a>

                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <!--breadcrumb end -->

      <!-- blog Section starts -->
      <section>
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="blog-item">
                <div class="blog-block">
                  <div class="blog-box">
                    <div class="overflow-hidden">
                      <a href="#">
                        <img
                          src="../assets/images/blog/blog-details.jpg"
                          alt="blog"
                          class="img-fluid"
                        >
                      </a>
                    </div>
                  </div>
                </div>
                <div class="blog-text">
                  <h6>25 january 2018</h6>
                  <a href="#">
                    <h3 class="blog-head">How to Pay for Car Repairs If You Don’t Have an Emergency Fund
                    </h3>
                  </a>
                  <div class="blog-divider" />
                  <div class="blog-description">
                    <p>
                      It’s not rocket science to know that having money saved for a rainy day is smart. We love to encourage people to build an emergency savings fund to prepare for the unexpected. As The Atlantic recently featured, the reality for many people is that saving hundreds or thousands of dollars is a struggle.

                      Expensive calamities don’t wait. When your car breaks down, it’s not helpful to hear that you should have anticipated the expense months ago. Fortunately, you have options to pay for car repairs even if you don’t have savings.
                    </p>
                    <p>
                      If the car got damaged in an accident, your insurance provider should offer emergency roadside assistance coverage and cover repair expenses after you meet your deductible.

                      If the car broke down but was not in an accident, you might still be able to access free help. First, check with your auto insurance provider (call the number on your proof of insurance.) Members of AAA can get roadside help from trustworthy providers. Organizations like the AARP and some motor clubs provide this benefit as well. Roadside assistance can even come in the form of a credit card benefit. Also check with the dealer where you bought your car (even if you bought it used).

                      Several major credit card companies and issuers offer emergency road services, check your credit card for which benefits are offered and what limitations and exclusions apply. Some premium accounts offers this perk for free, while others charge per service call, also any third party fees are the responsibility of the cardmember.
                    </p>
                    <p>
                      Of course, you want your car fixed as quickly as possible so you can resume your normal life. Take the time to find a good deal. Aim for at least three estimates from different reputable repair shops. Tell them you’re comparing offers and ask about any discounts they may have available. For repairs covered by insurance, your insurer will assess the damage and compensate you for what they judge to be the value of the repairs. In most cases, they are required to let you choose your repair shop.

                      Need to bring the price down even more? Call technical or vocational schools in your area. If they train students to work as auto mechanics, you may be able to work out a deal with an instructor to use your car in the classroom. Ask whether the instructor will assess your car and let the class work on it, what they will charge for parts, and what happens if they can’t repair the damage.

                      Beware of shops that promise to waive your deductible. Depending on where you live and your insurance company’s rules, this may or may not be legal. It’s a warning sign that the shop may not be ethical. Some shops inflate estimated repairs to get insurance companies to overpay, or recoup the money they “save” you by installing inadequate parts. Waiving a deductible isn’t always a giveaway of a crooked business, but it’s reason to be cautious.
                    </p>
                    <h5>Mark jkcno</h5><h5 class="pull-right">
                      10 <i class="fa fa-heart-o" />, 50 <i class="fa fa-comments-o" />
                    </h5>
                  </div>
                </div>
              </div>
              <div class="blog-divider" />
              <div class="row">
                <div class="col-md-10 offset-md-1 leave-coment">
                  <h3 class="text-center">
                    Leave Your Comment
                  </h3>
                  <form class="theme-form footer-form p-0 mt-3">
                    <div class="form-group">
                      <div class="row">
                        <div class="col-lg-6 col-md-12 md-fgrup-margin">
                          <input
                            type="text"
                            class="form-control"
                            placeholder="your name"
                          >
                        </div>
                        <div class="col-lg-6 col-md-12">
                          <input
                            id="exampleFormControlInput1"
                            type="email"
                            class="form-control"
                            placeholder="email address"
                          >
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <textarea
                        id="exampleFormControlTextarea1"
                        class="form-control"
                        rows="4"
                        placeholder="message"
                      />
                    </div>
                    <div class="form-button">
                      <button
                        type="submit"
                        class="btn btn-custom theme-color"
                      >
                        send
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--blog Section End-->
      <!--Footer Section start-->
      <js />
      <!--Footer Section End-->
    </div>
    <!--blog Section end -->
  </div>
</template>
<script>
export default {
  name: 'BlogDetails2',
}
</script>



// WEBPACK FOOTER //
// src/blog/blog_details2.vue